<script setup lang="ts"></script>

<template>
  <div class="mt-4 flex items-center justify-end pt-2 space-x-4">
    <slot></slot>
  </div>
</template>
